import { ContractTransactionResponse } from "ethers";

import { ConnectedProvider, VerifiableCredential, ZkProof } from "../domain";
import { ReputationVerifier__factory } from "../types/contracts/reputation-verifier";

export const sendZkProofTx = async (
  provider: ConnectedProvider,
  vc: VerifiableCredential,
  zkProof: ZkProof
): Promise<ContractTransactionResponse> => {
  try {
    const signer = await provider.provider.getSigner();

    if (vc.proof.cryptosuite === "merklize-sponge6-eth") {
      const contract = ReputationVerifier__factory.connect(
        import.meta.env.VITE_APP_REPUTATION_ETH_VERIFIER_CONTRACT_ADDRESS,
        signer
      );
      const requestId = 1;
      const {
        proof: { pi_a, pi_b, pi_c },
      } = zkProof;

      return contract.submitZKPResponse(
        requestId,
        zkProof.publicSignals,
        [pi_a[0], pi_a[1]],
        [
          [pi_b[0][1], pi_b[0][0]],
          [pi_b[1][1], pi_b[1][0]],
        ],
        [pi_c[0], pi_c[1]],
        vc.proof.proofValue,
        { gasLimit: 2000000, chainId: 31337 }
      );
    } else {
      const contract = ReputationVerifier__factory.connect(
        import.meta.env.VITE_APP_REPUTATION_BJJ_VERIFIER_CONTRACT_ADDRESS,
        signer
      );
      const requestId = 2;
      const {
        proof: { pi_a, pi_b, pi_c },
      } = zkProof;

      return contract.submitZKPResponse(
        requestId,
        zkProof.publicSignals,
        [pi_a[0], pi_a[1]],
        [
          [pi_b[0][1], pi_b[0][0]],
          [pi_b[1][1], pi_b[1][0]],
        ],
        [pi_c[0], pi_c[1]],
        "0x",
        { gasLimit: 2000000, chainId: 31337 }
      );
    }
  } catch (e) {
    console.error(e);
    throw new Error("An error occurred while sending the zkProof to the SC");
  }
};
